module.exports = __webpack_public_path__ + "static/media/10@1280w.fd82034b.jpg";